// Base path for all pre-launch APIs
const BASE = '/api/v5';

// POST  – trigger pre-launch analysis (requires campaignId in body)
export const URL_PRELAUNCH_TRIGGER = `${BASE}/campaignPreAnalysis`;

// GET   – poll status: ?campaignId=X  or  ?reportId=X
export const URL_PRELAUNCH_STATUS = `${BASE}/getPreLaunchStatus`;

// POST  – retrigger (requires campaignId in body)
export const URL_PRELAUNCH_RETRIGGER = `${BASE}/retriggerPreLaunch`;

// GET   – full metrics report: ?campaignId=X  or  ?reportId=X
export const URL_PRELAUNCH_REPORT = `${BASE}/getPreLaunchReport`;

// GET   – run history list: ?campaignId=X
export const URL_PRELAUNCH_HISTORY = `${BASE}/getPreLaunchReportHistory`;

// GET   – drill-down detail: ?reportId=X[&type=scope|dq|risk|guardrails][&page=0&max=25][&filter=...]
export const URL_PRELAUNCH_DETAIL = `${BASE}/getPreLaunchDetail`;

// GET   – filter/dropdown options (no params required)
export const URL_PRELAUNCH_FILTER_OPTIONS = `${BASE}/getPreLaunchFilterOptions`;

// GET   – download report: ?reportId=X&format=xlsx
export const URL_PRELAUNCH_DOWNLOAD = `${BASE}/downloadPreLaunchReport`;

// POST  – launch campaign from pre-launch (requires campaignId in body)
export const URL_PRELAUNCH_LAUNCH = `${BASE}/launchFromPreLaunch`;

// POST  – preview campaign from pre-launch (requires campaignId in body)
export const URL_PRELAUNCH_PREVIEW = `${BASE}/previewFromPreLaunch`;
